'use client'

import { toast } from 'sonner'
import { VariantProps } from 'class-variance-authority'
import { faClose } from '@fortawesome/pro-regular-svg-icons'
import { mtc, TypographyStyles } from '../../../utils/style-helpers'
import { Card } from '../../atoms/card'
import { Button } from '../../atoms/button'
import { Text } from '../../atoms/text'
import { bodyLeftStyle, cardStyle } from './styles'

interface ToastProps {
  close?: boolean
  id: string | number
  title: string
  description: string
  button?: {
    label: string
    onClick: () => void
  }
  variant?: VariantProps<typeof cardStyle>['variant']
}

export const Toast = ({
  button,
  close,
  description,
  id,
  title,
  variant,
}: ToastProps) => {
  const buttonVariant = variant === 'danger' ? 'danger' : 'secondary'

  return (
    <Card className={mtc(cardStyle({ variant }))}>
      <div className={mtc(bodyLeftStyle())}>
        <Text variant={TypographyStyles.LABEL_SM}>{title}</Text>
        <Text variant={TypographyStyles.BODY_SM}>{description}</Text>
      </div>

      {button?.label && button.onClick && (
        <Button
          aria-label="toast action"
          onClick={() => {
            button.onClick()
            toast.dismiss(id)
          }}
          variant={buttonVariant}
        >
          {button.label}
        </Button>
      )}

      {close && (
        <Button
          aria-label="dismiss card"
          className="text-neutral-500 absolute top-0 right-0"
          iconRight={faClose}
          onClick={() => {
            toast.dismiss(id)
          }}
          variant="discreet"
          size="square"
        />
      )}
    </Card>
  )
}

export const handleToast = ({
  button,
  close,
  description,
  title,
  variant,
}: Omit<ToastProps, 'id'>) => {
  return toast.custom(
    (id) => (
      <Toast
        button={
          button?.label && button?.onClick
            ? {
                label: button.label,
                onClick: button.onClick,
              }
            : undefined
        }
        close={close}
        description={description}
        id={id}
        title={title}
        variant={variant}
      />
    )
    // { duration: Infinity } // Uncomment for debugging
  )
}
